import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * O nome da tela, como `<h1>` — um por tela, e o maior título dela.
 *
 * DOIS DEFEITOS MORREM AQUI, e eles são o mesmo defeito visto de dois lados.
 *
 * 1. OITO DAS ONZE TELAS NÃO TINHAM `<h1>` NENHUM. Saúde, Resultado, Caixa e
 *    Ciclo, Dívida e Retorno, Análise, DRE, Planos e Fechar o mês abriam direto
 *    num bloco `<h2>`, então o sumário que um leitor de tela monta começava no
 *    meio da hierarquia. Quem navega por títulos não tinha como saber em que
 *    tela estava.
 *
 * 2. ONDE O `<h1>` EXISTIA, ELE ERA IDÊNTICO AO `<h2>`. As páginas usavam
 *    `variant="h4"` para o h1 e o `Bloco` usa `variant="h4"` para o h2: os dois
 *    saíam 20px/650 no DOM, medidos. Hierarquia que não se vê não é hierarquia.
 *    Aqui o h1 é `h3` (23px), estritamente maior que o h2 dos blocos.
 *
 * De quebra ele resolve o título espremido do cabeçalho no celular: a 390px a
 * barra do topo cortava "Painel de Indicadores" em "P.", porque os botões
 * comem a largura. O nome da tela passa a viver no conteúdo, onde há espaço
 * para ele por inteiro.
 */
const TituloDaTela = ({ titulo, descricao, acao }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    justifyContent="space-between"
    alignItems={{ xs: 'flex-start', sm: 'center' }}
    spacing={1}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="h3"
        component="h1"
        sx={{
          // Tracking negativo maior que o do corpo: título grande com o
          // espaçamento de texto de leitura parece frouxo. É o mesmo ajuste
          // ótico que o número protagonista recebe.
          letterSpacing: '-0.028em'
        }}
      >
        {titulo}
      </Typography>
      {descricao && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: '65ch' }}>
          {descricao}
        </Typography>
      )}
    </Box>
    {acao && <Box sx={{ flexShrink: 0 }}>{acao}</Box>}
  </Stack>
);

export default TituloDaTela;
